export default {
  other: "Other",
};
